/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import zIndex from "@mui/material/styles/zIndex";
import Modal from "react-modal";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onChange?: () => void;
  title?: string;
  content?: JSX.Element | string;
  btnTitle?: string;
};

//TODO: 추후에 컴포넌트화 시켜야합니다.
const DeleteWarningModal = (props: Props) => {
  const { modalIsOpen, closeModal, onChange, title, content, btnTitle } = props;

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        <CancelIcon>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelIcon>
        <CautionIcon>
          <UI.Icon name="inform" size={56} color="var(--alias-color-status-negative)" />
        </CautionIcon>
        <UI.Typography type="heading01" fontStyle="bold" color="var(--alias-color-label-normal)">
          {title}
        </UI.Typography>
        <UI.Typography
          type="body01 normal"
          fontStyle="medium"
          color="var(--alias-color-label-alternative)"
          style={{ marginTop: "16px" }}
        >
          {content}
        </UI.Typography>
        <div style={{ display: "flex", gap: "12px", marginTop: "40px" }}>
          <UI.Button
            type="outlined"
            title="취소하기"
            size="large"
            primary
            style={{ width: "100%" }}
            onClick={closeModal}
          />
          <UI.Button title="삭제하기" size="large" primary style={{ width: "100%" }} onClick={onChange} />
        </div>
      </Container>
    </Modal>
  );
};

export default DeleteWarningModal;

const Container = styled.div`
  width: 454px;
  padding: 48px;
  box-sizing: border-box;
  background-color: white;
  box-shadow: var(--alias-style-shadow-heavy);
  border-radius: 20px;
  position: relative;
  align-items: center;
  text-align: center;
  word-break: keep-all;
`;

const CancelIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

const CautionIcon = styled.div`
  box-shadow: 0px 0px 40px 0px rgba(255, 62, 62, 0.4);
  width: 47px;
  height: 47px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 24px;
`;
